import BaseFormPresenter from "../../../../base/BaseFormPresenter";

class EmployeeEarningsFormPresenter extends BaseFormPresenter {
  onChangeObject(object) {
    this.change = object;
    this.object = object;
  }

  async componentDidMount() {
    const fetchPayrolls = await this._fetchData();
    this.view.setState({ fetchPayrolls });
  }

  async _fetchData() {
    try {
      const { employeeInfo, payrollType } = this.view.props.panelInfo;
      const type = payrollType === "basic" ? "Basic Pay" : "Augmentation Pay";
      const employeeId = employeeInfo?.id;

      // const payrollPrinted = await findObjectUseCase().execute("payroll_list", {
      //   where: {
      //     stats: "Printed",
      //     payrollType: type,
      //   },
      // });
      // let ids = [];
      // for (const payroll of payrollPrinted) {
      //   ids.push(payroll?.id);
      // }

      // const payrollRecord = await findObjectUseCase().execute("payroll", {
      //   where: {
      //     payrollID: { $in: ids },
      //     "employee.id": employeeId,
      //   },
      // });

      // console.log("payrollRecord", payrollRecord);

      return {
        // payrollPrinted,
        // payrollRecord,
      };
    } catch (error) {
      console.log("Error fetching data!", error);
    }
  }
}

export default EmployeeEarningsFormPresenter;
